import { render, staticRenderFns } from "./cursoStatus.vue?vue&type=template&id=74ebe568&"
import script from "./cursoStatus.vue?vue&type=script&lang=js&"
export * from "./cursoStatus.vue?vue&type=script&lang=js&"
import style0 from "./cursoStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports